export default (params) => ({
  trigger: {
    name: 'content_blocks.article_list.select_article',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      article_link_title: {
        type: 'string',
      },
      article_url: {
        type: 'string',
      },
      article_id: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'one_list',
          'two_lists',
          'three_lists',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_article',
      params: {
        has_video: null,
      },
    },
  },
});
